import DeleteButton from "@main-components/buttons/delete-button";
import EditFormContainer from "@main-components/forms/edit-form-container";
import SimpleForm from "@main-components/forms/simple-form";
import TextInput from "@main-components/inputs/text-input";
import * as React from "react";
import { FieldProps, required, ShowButton, TopToolbar } from "react-admin";

const AdminTitle: React.FC<FieldProps> = ({ record }) => {
  return <span>Admin {record ? `"${record.email}"` : ""}</span>;
};

const AdminEditActions = (props) => {
  return (
    <TopToolbar {...props}>
      <ShowButton
        record={props.data}
        basePath="/accounts"
        // variant="outline"
        className="mr-1"
      />

      <DeleteButton
        {...props}
        undoable={false}
        record={props.data}
        basePath="/accounts"
        variant="outline"
      />
    </TopToolbar>
  );
};
const AdminEdit = (props) => (
  <EditFormContainer
    {...props}
    title={<AdminTitle />}
    undoable={false}
    actions={<AdminEditActions />}
  >
    <SimpleForm redirect="show" undoable={false}>
      <TextInput
        source="firstName"
        label="general.first_name"
        validate={[required()]}
      />
      <TextInput
        source="lastName"
        label="general.last_name"
        validate={[required()]}
      />
    </SimpleForm>
  </EditFormContainer>
);

export default AdminEdit;
